var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-input-container"},[_c('Cleave',{class:_vm.input_class,attrs:{"raw":false,"options":_vm.options,"placeholder":_vm.placeholder,"name":_vm.name,"value":_vm.date,"autocomplete":"off"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }